import React, { Fragment } from "react";
import { useAgeRanges } from "../../vocabularyServices";
import Select from "@material-ui/core/Select";
import { InputLabel, MenuItem } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import { Skeleton } from "@material-ui/lab";
import FormHelperText from "@material-ui/core/FormHelperText";
import { notBlank } from "../../../util/ext";

const AgeRangeSelect = props => {
  const {
    onBlur,
    onChange,
    value,
    valueFormat = "name",
    label = "Age Range",
    required = false,
    error = false,
    helperText = "",
  } = props;
  const ageRanges = useAgeRanges();

  return (
    <Fragment>
      {ageRanges.isLoading ? (
        <Skeleton variant="text" />
      ) : (
        <FormControl fullWidth required={required} error={error}>
          <InputLabel htmlFor="age-range">{label}</InputLabel>
          <Select
            value={value || ""}
            onChange={onChange}
            inputProps={{
              name: "age-range",
              id: "age-range",
            }}
            onBlur={onBlur}
          >
            <MenuItem value={null} key="no-age-range">
              <i>None</i>
            </MenuItem>
            {ageRanges.data.map(ar => {
              return (
                <MenuItem
                  value={valueFormat === "name" ? ar.name : ar}
                  key={ar.name}
                >
                  {ar.display}
                </MenuItem>
              );
            })}
          </Select>
          {notBlank(error) && <FormHelperText>{helperText}</FormHelperText>}
        </FormControl>
      )}
    </Fragment>
  );
};

export default AgeRangeSelect;
